// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const PlanPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-planpage" */ "./PlanPage")).then((bundle)=>{
        return {
            default: bundle.PlanPage
        };
    });
export const LazyPlanPage = /*#__PURE__*/ lazy(PlanPageLazyLoader);
